import { createAction } from 'redux-actions'

import { FETCH_ROUTES, FETCH_ROUTES_ERROR, FETCH_ROUTES_SUCCESS, SET_ROUTES_STATE } from './consts'

export const fetchRoutes = createAction(FETCH_ROUTES)
export const fetchRoutesSuccess = createAction(FETCH_ROUTES_SUCCESS, (payload) => payload)
export const fetchRoutesError = createAction(FETCH_ROUTES_ERROR)

export const setRoutesState = createAction(SET_ROUTES_STATE)
